import {
    CREATE_SKU_MASTER_HEADER_REQUEST,
    CREATE_SKU_MASTER_HEADER_SUCCESS,
    CREATE_SKU_MASTER_HEADER_FAILURE,
    DELETE_SKU_MASTER_HEADER_REQUEST,
    DELETE_SKU_MASTER_HEADER_SUCCESS,
    DELETE_SKU_MASTER_HEADER_FAILURE,
    FETCH_SINGLE_SKU_MASTER_HEADER_REQUEST,
    FETCH_SINGLE_SKU_MASTER_HEADER_SUCCESS,
    FETCH_SINGLE_SKU_MASTER_HEADER_FAILURE,
    FETCH_SKU_MASTER_HEADER_REQUEST,
    FETCH_SKU_MASTER_HEADER_SUCCESS,
    FETCH_SKU_MASTER_HEADER_FAILURE,
    UPDATE_SKU_MASTER_HEADER_REQUEST,
    UPDATE_SKU_MASTER_HEADER_SUCCESS,
    UPDATE_SKU_MASTER_HEADER_FAILURE,
    RESET_SKU_MASTER_HEADER_INFO,
    CREATE_SKU_MASTER_HEADER_FORM,
    UPDATE_SKU_MASTER_HEADER_FORM,
    NAVIGATE_SKU_MASTER_HEADER,
    NAVIGATE_SKU_MASTER_DETAIL,
    FETCH_SKU_MASTER_HEADER_WITH_ID_SUCCESS,
    FETCH_SKU_MASTER_HEADER_WITH_ID_REQUEST,
    FETCH_SKU_MASTER_HEADER_WITH_ID_FAILURE,
    CREATE_SKU_MASTER_HEADER_IMAGE_REQUEST,
    CREATE_SKU_MASTER_HEADER_IMAGE_SUCCESS,
    CREATE_SKU_MASTER_HEADER_IMAGE_FAILURE,
    SET_ACTIVE_KEY_SKU_MASTER,
    SET_XLSX_DATA_OF_SKU_MASTER,
    FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_REQUEST,
    FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_SUCCESS,
    FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_FAILURE,
    FETCH_SKU_MASTER_DETAILS_GRID_REQUEST,
    FETCH_SKU_MASTER_DETAILS_GRID_FAILURE,
    FETCH_SKU_MASTER_DETAILS_GRID_SUCCESS,
    FETCH_SKU_MASTER_SIZE_HEADER_REQUEST,
    FETCH_SKU_MASTER_SIZE_HEADER_SUCCESS,
    FETCH_SKU_MASTER_SIZE_HEADER_FAILURE,
    UPDATE_SKU_MASTER_SIZE_HEADER_REQUEST,
    UPDATE_SKU_MASTER_SIZE_HEADER_SUCCESS,
    UPDATE_SKU_MASTER_SIZE_HEADER_FAILURE,
    HANDLE_SKU_SIZE_MODAL,
    UPDATE_SKU_MASTER_SIZE_HEADER_FORM,
    FETCH_SKU_MASTER_HEADER_SIZE_REQUEST,
    FETCH_SKU_MASTER_HEADER_SIZE_SUCCESS,
    FETCH_SKU_MASTER_HEADER_SIZE_FAILURE
} from './skuMasterHeader.actionsType';

export const SKU_MASTER_HEADER = 'skuMasterHeader';

let initialState = {
    loading: false,
    skuMasterHeder: [],
    skuMasterSizeDataHeder: {},
    skuMasterHederWithoutId: [],
    skuMasterHederWithStyleName: [],
    skuMasterHederDetailsGridList: [],
    skuMasterHeaderForm: {
        fldDiscountPercentage: 0,
        fldRate: 0,
        fldSellingRate: 0,
        fldTPRate: 0
    },
    selectedState: {},
    activeKey: 1,
    excelData: [],
    skuMasterSizeID: [],
    errorMessage: '',
    skuSizeModal: false,
    skuMasterHeaderSizeForm: {},
    singleSkuMasterHeader: {
        fldDiscountPercentage: 0,
        fldRate: 0,
        fldSellingRate: 0,
        fldTPRate: 0
    },
    isSkuDetail: false,
    colorDropdownData: null,
    sizeDropdownData: null
};

export let skuMasterHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_SKU_MASTER_HEADER_REQUEST:
        case FETCH_SKU_MASTER_SIZE_HEADER_REQUEST:
        case FETCH_SKU_MASTER_DETAILS_GRID_REQUEST:
        case CREATE_SKU_MASTER_HEADER_REQUEST:
        case CREATE_SKU_MASTER_HEADER_IMAGE_REQUEST:
        case UPDATE_SKU_MASTER_HEADER_REQUEST:
        case UPDATE_SKU_MASTER_SIZE_HEADER_REQUEST:
        case FETCH_SINGLE_SKU_MASTER_HEADER_REQUEST:
        case FETCH_SKU_MASTER_HEADER_WITH_ID_REQUEST:
        case FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_REQUEST:
        case DELETE_SKU_MASTER_HEADER_REQUEST:
        case FETCH_SKU_MASTER_HEADER_SIZE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SKU_MASTER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHederWithoutId: updatePayload
            };
        case FETCH_SKU_MASTER_HEADER_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterSizeID: updatePayload
            };
        case FETCH_SKU_MASTER_SIZE_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderSizeForm: updatePayload && updatePayload.length > 0 ? updatePayload[0] : {},
                skuMasterSizeDataHeder: updatePayload && updatePayload.length > 0 ? updatePayload[0] : {},
                skuSizeModal: updatePayload && updatePayload.length > 0 ? true : false
            };
        case FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHederWithStyleName: updatePayload
            };
        case FETCH_SKU_MASTER_DETAILS_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHederDetailsGridList: updatePayload
            };
        case FETCH_SKU_MASTER_HEADER_WITH_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeder: updatePayload
            };
        case CREATE_SKU_MASTER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderForm: {
                    fldDiscountPercentage: 0,
                    fldRate: 0,
                    fldSellingRate: 0,
                    fldTPRate: 0
                }
            };
        case CREATE_SKU_MASTER_HEADER_IMAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderForm: {
                    fldDiscountPercentage: 0,
                    fldRate: 0,
                    fldSellingRate: 0,
                    fldTPRate: 0
                }
            };
        case UPDATE_SKU_MASTER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderForm: {
                    fldDiscountPercentage: 0,
                    fldRate: 0,
                    fldSellingRate: 0,
                    fldTPRate: 0
                }
            };
        case UPDATE_SKU_MASTER_SIZE_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderSizeForm: {}
            };
        case FETCH_SINGLE_SKU_MASTER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderForm: updatePayload
            };
        case DELETE_SKU_MASTER_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterHeaderForm: {
                    fldDiscountPercentage: 0,
                    fldRate: 0,
                    fldSellingRate: 0,
                    fldTPRate: 0
                }
            };
        case RESET_SKU_MASTER_HEADER_INFO:
            return {
                ...state,
                skuMasterHeaderForm: {
                    fldDiscountPercentage: 0,
                    fldRate: 0,
                    fldSellingRate: 0,
                    fldTPRate: 0
                },
                activeKey: 1,
                excelData: []
            };
        case CREATE_SKU_MASTER_HEADER_FORM:
        case UPDATE_SKU_MASTER_HEADER_FORM:
            return {
                ...state,
                loading: false,
                skuMasterHeaderForm: {
                    ...state.skuMasterHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case UPDATE_SKU_MASTER_SIZE_HEADER_FORM:
            return {
                ...state,
                loading: false,
                skuMasterHeaderSizeForm: {
                    ...state.skuMasterHeaderSizeForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_SKU_MASTER:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_XLSX_DATA_OF_SKU_MASTER:
            return {
                ...state,
                loading: false,
                excelData: payload
            };
        case FETCH_SKU_MASTER_HEADER_FAILURE:
        case FETCH_SKU_MASTER_SIZE_HEADER_FAILURE:
        case FETCH_SKU_MASTER_DETAILS_GRID_FAILURE:
        case FETCH_SKU_MASTER_HEADER_WITH_ID_FAILURE:
        case FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_FAILURE:
        case CREATE_SKU_MASTER_HEADER_FAILURE:
        case CREATE_SKU_MASTER_HEADER_IMAGE_FAILURE:
        case UPDATE_SKU_MASTER_HEADER_FAILURE:
        case UPDATE_SKU_MASTER_SIZE_HEADER_FAILURE:
        case FETCH_SINGLE_SKU_MASTER_HEADER_FAILURE:
        case DELETE_SKU_MASTER_HEADER_FAILURE:
        case FETCH_SKU_MASTER_HEADER_SIZE_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_SKU_MASTER_DETAIL:
            return {
                ...state,
                isSkuDetail: true,
                singleSkuMasterHeader: updatePayload.singleSkuMasterHeader
            };
        case HANDLE_SKU_SIZE_MODAL:
            return {
                ...state,
                skuSizeModal: payload
            };
        case NAVIGATE_SKU_MASTER_HEADER:
            return {
                ...state,
                isSkuDetail: false
            };

        default:
            return state;
    }
};
